module.exports = __webpack_public_path__ + "img/chest.24073088.png";